import { i18n } from "../../../translate/i18n";
import { NodeWrapper } from "./NodeWrapper";
import { mkHeaderStyle, HEADER_ICON_STYLE, HEADER_TEXT_STYLE, NODE_BODY_STYLE, NODE_INFO_ROW } from "./nodeStyles";
import React, { memo } from "react";
import { Box, Typography, IconButton, Chip } from "@mui/material";
import { useTheme } from "@material-ui/core/styles";
import { NotificationsActive as NotifierIcon, ContentCopy as ContentCopyIcon, DeleteOutline as DeleteOutlineIcon } from '@mui/icons-material';
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import './css/inputNode.css';

import { Tooltip as CoreTooltip, IconButton as CoreIconButton } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1e293b',
    color: '#f8fafc',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #334155',
    padding: '12px 14px',
    borderRadius: '8px',
    fontFamily: "'Inter', 'Roboto', sans-serif",
    lineHeight: 1.5,
  },
  arrow: { color: '#1e293b' },
}))(CoreTooltip);

const useStyles = makeStyles((theme) => ({
  pulseIcon: {
    color: '#ffffff',
    borderRadius: '50%',
    animation: '$glowPulse 1.5s infinite',
  },
  '@keyframes glowPulse': {
    '0%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.9)' },
    '70%': { boxShadow: '0 0 0 8px rgba(255, 255, 255, 0)' },
    '100%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' },
  },
}));

export default memo(({
  data,
  isConnectable,
  id,
  selected
}) => {
  const classes = useStyles();

  const theme = useTheme();
  const storageItems = useNodeStorage();
  return <NodeWrapper id={id} selected={selected} color="#06B6D4">
    <Handle type="target" position="left" style={{
      left: -12,
      top: "20px",
      background: "#06B6D4",
      width: 10,
      height: 20,
      cursor: 'pointer',
      borderRadius: "4px",
      border: '2px solid white',
      zIndex: 1
    }} isConnectable={isConnectable} />



    <div style={mkHeaderStyle("#06B6D4")}>
      <NotifierIcon style={HEADER_ICON_STYLE} />
      <div style={HEADER_TEXT_STYLE}>{data.name || "Notificador"}</div>
    
        <HtmlTooltip
          arrow
          title={
            <React.Fragment>
              <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#22d3ee' }}>
                💡 {i18n.t("flowBuilder.tooltips.notifier.title")}
              </div>
              <div style={{ marginBottom: '0' }}>
                <div dangerouslySetInnerHTML={{ __html: i18n.t("flowBuilder.tooltips.notifier.body") }} />
              </div>
            </React.Fragment>
          }
          placement="right"
        >
          <CoreIconButton size="small" style={{ padding: '4px', marginLeft: '2px' }} className={classes.pulseIcon}>
            <HelpOutlineIcon style={{ fontSize: '15px' }} />
          </CoreIconButton>
        </HtmlTooltip>
      </div>

    <div style={NODE_BODY_STYLE}>
      <div style={{ ...NODE_INFO_ROW, position: 'relative', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontWeight: 400 }}>
          Destino:
        </Typography>
        {data.destinationNumber ? <Chip label={data.destinationNumber} size="small" sx={{
          height: 24,
          fontSize: '0.85rem',
          bgcolor: '#d1fae5',
          color: '#06B6D4',
          border: '1px solid #a7f3d0'
        }} /> : <Typography variant="body2" color="text.secondary" sx={{
          fontStyle: 'italic',
          fontSize: '13px'
        }}>
          No definido
        </Typography>}
        <Handle type="source" position="right" id="a" style={{ background: "#06B6D4", width: "10px", height: "20px", borderRadius: "4px", cursor: "pointer", border: "2px solid white", top: "50%", transform: "translateY(-50%)", right: -25 }} isConnectable={isConnectable} />
      </div>
    </div>


  </NodeWrapper>;
});
